/**
 * Calculate the percentage of recipe ingredients that a user has in their pantry
 * @param {Array} pantryIngredients - Array of pantry ingredients with ingredient_id and quantity
 * @param {Array} recipeIngredients - Array of recipe ingredients with ingredient_id
 * @returns {number} - Percentage match (0-100)
 */
export const calculatePantryMatch = (pantryIngredients, recipeIngredients) => {
  // Handle edge cases
  if (!Array.isArray(recipeIngredients) || recipeIngredients.length === 0) {
    return 0;
  }

  if (!Array.isArray(pantryIngredients) || pantryIngredients.length === 0) {
    return 0;
  }

  // Create a Set of ingredient IDs from pantry that have non-zero quantity
  const pantryIngredientIds = new Set(
    pantryIngredients
      .filter(item => {
        const quantity = parseFloat(item.quantity);
        return !isNaN(quantity) && quantity > 0;
      })
      .map(item => item.ingredient_id)
  );

  // Count how many recipe ingredients the user has
  let matchCount = 0;
  recipeIngredients.forEach(recipeIngredient => {
    const ingredientId = recipeIngredient.ingredient_id || recipeIngredient.ingredientId;
    if (ingredientId && pantryIngredientIds.has(ingredientId)) {
      matchCount++;
    }
  });

  // Calculate percentage
  const percentage = (matchCount / recipeIngredients.length) * 100;
  
  // Round to nearest integer
  return Math.round(percentage);
};

